import { Grid } from "@material-ui/core";
import { SearchIcon } from "App/Assets";
import { FormTipeKartuNoKartuDanNoTransfer } from "App/Component/layout/Tagihan/InputTagihan/ui/TabBayar/helpers";
import {
  InputOptionMaster,
  InputReactDatepicker,
  InputTextMaster,
  MasterButton,
} from "App/Component/ui";
import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance4,
  TYPE_INSTANCE3,
  valueTipePembayaran,
} from "App/constants";
import { useSelectOption } from "App/hooks";
import {
  convertToValidPrice,
  defaultToastError,
  defaultToastSuccess,
  formatNumber,
  formatRupiah,
  isNull,
  toUTCFormat,
} from "App/utils/helpers";
import React, { useState } from "react";
import { LIST_URL_MASTER } from "utils/masters";
import { LIST_URL_WAREHOUSE } from "utils/warehouse";
import { RESET_STATE_PEMBAYARAN } from "./helpers";
import ModalListPembelian from "./ModalListPembelian";

function FormInputPembayaran({
  setNewDataPembayaranByPembelian,
  setTotal,
  total,
  formData,
  setFormData,
}) {
  const [showModalListPembelian, setShowModalListPembelian] = useState(false);
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    });
  };

  const kasBank = useSelectOption(
    true,
    LIST_URL_MASTER.kas.list,
    TYPE_INSTANCE3,
    "id",
    "nama"
  );

  const handleClickSelect = async (row) => {
    setTotal({
      ...total,
      totalPembelian: row.totalPembelian,
    });
    setFormData({
      ...formData,
      pembelian_id: row.id,
      jumlah_bayar2: formatNumber(row.sisa),
      kas_id: row?.kasbank_id,
      kas_name: row?.namaKasBank,
    });

    setShowModalListPembelian(false);
  };

  const save = async () => {
    const defaultData = {
      tanggal_masuk: toUTCFormat(formData.tanggal_masuk),
      jumlah_bayar: convertToValidPrice(formData.jumlah_bayar2),
      tipe_pembayaran_id: formData.tipe_pembayaran_id,
      kas_id: formData.kas_id,
      tipe_kartu: formData.tipe_kartu,
      no_kartu: formData.no_kartu,
      no_transfer: formData.no_transfer,
      kartu_bank: formData.kartu_bank,
      pembelian_id: formData.pembelian_id,
    };

    return instance4.post(LIST_URL_WAREHOUSE.PembayaranPBF.add, defaultData);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);
    const pembelianID = formData.pembelian_id;
    if (isNull(formData.pembelian_id) || isNull(formData.kas_id)) {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      defaultToastError("Pembelian atau Kas tidak boleh kosong");
    } else {
      try {
        if (
          total.totalPembelian <
          parseFloat(total.totalPembayaran) +
            parseFloat(convertToValidPrice(formData.jumlah_bayar2))
        ) {
          defaultToastError("Pembayaran melebihi total pembelian");
        } else {
          const res = await save();

          if (res.data.status === 200) {
            defaultToastSuccess("Berhasil menambah data");
            setFormData({
              ...RESET_STATE_PEMBAYARAN,
              pembelian_id: pembelianID,
            });
            await setNewDataPembayaranByPembelian(pembelianID);
          } else {
            defaultToastError(res.data.message);
          }
        }

        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      } catch (error) {
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        defaultToastError(error?.response?.data?.message);
      }
    }
  };

  return (
    <>
      {showModalListPembelian && (
        <ModalListPembelian
          setShowModal={() => setShowModalListPembelian(false)}
          handleClickSelect={handleClickSelect}
        />
      )}

      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={1}>
          <Grid item sm={12}>
            <InputTextMaster
              name='pembelian_id'
              label='ID Pembelian'
              id='pembelian_id'
              value={formData.pembelian_id}
              placeholder={formData.pembelian_id}
              disabled={true}
              withButton={true}>
              <button
                type={"button"}
                onClick={() =>
                  setShowModalListPembelian(!showModalListPembelian)
                }
                style={{
                  borderRight: "1px solid #EAEAEA",
                  borderTop: "1px solid #EAEAEA",
                  borderBottom: "1px solid #EAEAEA",
                  borderLeft: "0",
                  background: "#fff",
                  padding: "0 0.8rem",
                  cursor: "pointer",
                  borderRadius: "0 6px 6px 0",
                }}>
                <SearchIcon width={"16"} height={"16"} fill={"#333"} />
              </button>
            </InputTextMaster>
          </Grid>
          <Grid item sm={6}>
            <InputReactDatepicker
              selected={formData.tanggal_masuk}
              label='TANGGAL MASUK'
              dateFormat='dd/MM/yyyy HH:mm'
              timeFormat='HH:mm'
              showTimeSelect
              timeIntervals={5}
              handleChangeToday={(e) =>
                setFormData({
                  ...formData,
                  tanggal_masuk: e,
                })
              }
              onChange={(e) =>
                setFormData({
                  ...formData,
                  tanggal_masuk: e,
                })
              }
            />
          </Grid>
          <Grid item sm={6}>
            <InputOptionMaster
              name='tipe_pembayaran_id'
              label='TIPE PEMBAYARAN'
              id='tipe_pembayaran_id'
              withSearch={false}
              value={formData.tipe_pembayaran_id}
              onChange={handleChange("tipe_pembayaran_id")}
              data={valueTipePembayaran}
            />
          </Grid>
          <Grid item sm={6}>
            <InputOptionMaster
              name='kas_id'
              label='KAS'
              id='kas_id'
              data={kasBank}
              withSearch={true}
              value={formData.kas_id}
              labelValue={formData.kas_name}
              onChange={(e) => {
                if (isNull(e)) {
                  setFormData({
                    ...formData,
                    kas_id: null,
                    kas_name: "Pilih kas",
                  });
                } else {
                  setFormData({
                    ...formData,
                    kas_id: e?.value,
                    kas_name: e?.label,
                  });
                }
              }}
            />
          </Grid>
          <Grid item sm={6}>
            <InputTextMaster
              name='jumlah_bayar2'
              label='PEMBAYARAN'
              id='jumlah_bayar2'
              value={formData.jumlah_bayar2}
              onChange={(e) => {
                let val = e.target.value;
                if (isNull(e)) {
                  setFormData({
                    ...formData,
                    jumlah_bayar2: val,
                  });
                } else {
                  setFormData({
                    ...formData,
                    jumlah_bayar2: formatRupiah(val),
                  });
                }
              }}
            />
          </Grid>
          {formData.tipe_pembayaran_id.toString() === "2" && (
            <Grid item sm={12}>
              <Grid container spacing={1}>
                <FormTipeKartuNoKartuDanNoTransfer
                  formData={formData}
                  handleChange={handleChange}
                />
              </Grid>
            </Grid>
          )}
        </Grid>
        <Grid
          container
          direction='row'
          justifyContent='space-between'
          alignItems='center'>
          <MasterButton
            className={"mt-1"}
            type='button'
            outline={true}
            color={"danger"}
            name={"RESET"}
            onClick={() => {
              setTotal({
                totalPembelian: 0,
                totalPembayaran: 0,
              });
              setFormData(RESET_STATE_PEMBAYARAN);
            }}
            size='md'
          />
          <MasterButton
            className={"mt-1"}
            type='submit'
            color={disabled.color}
            name={disabled.label}
            disabled={disabled.state}
            size='md'
          />
        </Grid>
      </form>
    </>
  );
}

export default FormInputPembayaran;
